import { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hook";
import {
  getAllRivers,
  getRiverById,
  createRiver,
  updateRiver,
  deleteRiver,
} from "src/services/damServices";
import {
  RIVERS_GET_ALL,
  RIVERS_GET_BY_ID,
  RIVERS_ADD,
  RIVERS_UPDATE,
  RIVERS_DELETE,
} from "src/store/river/action";

function useRiver() {
  const { rivers, selectedRiver } = useAppSelector((state) => state.river);
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);

  // Lấy tất cả sông
  const fetchRivers = async () => {
    try {
      setLoading(true);
      const response = await getAllRivers();
      dispatch(RIVERS_GET_ALL({ rivers: response.data }));
    } catch (error) {
      console.error("Error fetching rivers:", error);
    } finally {
      setLoading(false);
    }
  };

  // Lấy thông tin sông theo ID
  const fetchRiverById = async (riverId: string) => {
    try {
      const response = await getRiverById(riverId);
      dispatch(RIVERS_GET_BY_ID({ river: response.data }));
    } catch (error) {
      console.error("Error fetching river by ID:", error);
    }
  };

  // Tạo mới sông
  const addRiver = async (riverData) => {
    try {
      const response = await createRiver(riverData);
      dispatch(RIVERS_ADD({ river: response.data }));
      await fetchRivers();
    } catch (error) {
      console.error("Error creating river:", error);
    }
  };

  // Cập nhật sông
  const editRiver = async (riverData) => {
    try {
      const response = await updateRiver(riverData);
      dispatch(RIVERS_UPDATE({ river: response.data }));
      await fetchRivers();
    } catch (error) {
      console.error("Error updating river:", error);
    }
  };

  // 🔹 Xoá sông
  const removeRiver = async (riverId: string) => {
    try {
      await deleteRiver(riverId);
      dispatch(RIVERS_DELETE({ riverId }));
      await fetchRivers();
    } catch (error) {
      console.error("Error deleting river:", error);
    }
  };

  return {
    rivers,
    selectedRiver,
    isLoading,
    fetchRiverById,
    addRiver,
    editRiver,
    removeRiver,
    fetchRivers
  };
}

export default useRiver;
